import MediaQuestionEditorVM from './media-question-editor-vm';
export default function(params, videoEditor) {
  var self = this;

  self.videoEditor = videoEditor; // Reference to the parent video editor view model

  self.mapping = {
    include: ['cued_attributes'],
    ignore: ['delete', 'doneEditing', 'edit', 'goToTime', 'setTime']
  };

  ko.mapping.fromJS(params, self.mapping, self);

  self.formattedStartTime = ko.pureComputed({
    read: function () {
      var seconds = self.cue_start_time();
      var timeStr;
      var t = new Date(1970, 0, 1);
      t.setSeconds(Math.floor(seconds));
      timeStr = t.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
      //add fractional seconds
      var frac = Math.round10(seconds % 1, -3);
      if (frac > 0)
        timeStr += Math.round10(seconds % 1, -3).toString().substring(1);
      return timeStr;
    },

    write: function (value) {
      var secs = null;
      if (!isNaN(parseInt(value)) || value.match(/\d{2}:\d{2}:\d{2}(\.\d{1,3})?/)) {
        var timeArray = value.split(':');
        secs = 0.0;

        if (timeArray.length <= 3) {
          $.each(timeArray, function (ix, t) {
            secs += Math.pow(60.0, timeArray.length - ix - 1) * parseFloat(t);
          });
        }
      }

      if (secs !== null && secs >= 0.0 && secs <= self.videoEditor.renderer().duration()) {
        self.cue_start_time(secs);
      }
      else {
        Kadenze.UIUtil.displayMessage(Kadenze.I18n.t('session.media.validation_error.time_code_error_title'), Kadenze.I18n.t('session.media.validation_error.time_code_error'));
      }

      self.formattedStartTime.notifySubscribers();
    },

    owner: self
  });

  self.edit = function() {
    self.goToTime(self);

    //load template, add to document
    //need wrapper div to avoid ko 'multiple bindings' error
    var $cuesTable = $('#questions-' + self.videoEditor.id()),
      questionTemplate = Kadenze.I18n.tt(JST['templates/media-question-editor'](), 'en'),
      $editorView = $('<div/>', { class: 'media-question-editor'  }).append(questionTemplate),
      $cueEditor = $('#question-editor-' + self.videoEditor.id()).find('.question-editor');

    $cueEditor.append($editorView);
    $cuesTable.hide();

    var markupReference = {
      $table: $cuesTable,
      $editor: $cueEditor
    };

    var editorCallback = self.doneEditing.bind(self, markupReference);

    self.editorViewModel = new MediaQuestionEditorVM(ko.toJS(_.omit(self, 'videoEditor')), self.videoEditor.renderer(), editorCallback);
    ko.applyBindingsWithValidation(self.editorViewModel, $cueEditor.find(':first-child')[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  };

  self.doneEditing = function(markupReference, cue, cancel) {
    if (!cancel) {
      self.videoEditor.addOrUpdateQue(cue);
    }

    //cleanup
    if(markupReference) {
      markupReference.$editor.empty();
      markupReference.$table.show();
    }
  };

  self.setTime = function(cue) {
    cue.cue_start_time(Math.round10(self.videoEditor.renderer().currentTime(), -3).toString());
    cue.cue_end_time('-1.0');
  };

  self.goToTime = function(cue) {
    // Tell my video editor to go to my time
    self.videoEditor.goToCueTime(cue.cue_start_time());
  };

  self.delete = function(cue) {
    // Tell my video editor to delete me
    self.videoEditor.deleteCue(cue);
  };

  return self;
}


